import { Observable } from 'rxjs';
import { ConfigurationModel, UserModel } from '../../../models';

export abstract class AbstractConfigurationProvider {
  abstract getConfiguration(): ConfigurationModel;
  abstract getCurrentUserAsync(): Promise<UserModel>;
  abstract getAllUsers(): Observable<UserModel[]>;
}
